import React from "react";
import { data } from "./data";
import "./socials.css";

export const Socials = () => {
  const social = data;
  return (
    <div className="social">
      {social.map((item) => {
        return (
          <a href={item.link} rel="noreferrer" target="_blank">
            <div className="social-icons">
              <span className="social-icon">{item.icon}</span>
            </div>
          </a>
        );
      })}
    </div>
  );
};

export default Socials;
